import React from "react";
import "animate.css";
import managementImg from "../../../assets/management.png"

function WarehouseManagement() {
  const Instructions= [
    {
      title:"Able to design the warehouse",
    },
    {
      title:"Able to track items in the warehouse",
    },
    {
      title:"Able to know item history (production, quality, batch, supplier etc)",
    },
    {
      title:"Able to track orders, goods in and out",
    },
    {
      title:"Track items made by suppliers, sent to customers and even which shipping company has delivered it.",
    },
    
  ]
  return (
    <div className="animate__animated animate__zoomIn">
      <div className="container  w-11/12  shadow-5xl  mx-auto  px-8 py-8 my-28">
        <div className="grid grid-cols-2 gap-20 font-Montserrat">
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <h2 className="text-blue-200 text-2xl font-bold">
              Warehouse Management
            </h2>
            {Instructions.map((item, i) => (
             <div key={i} className="list-item pt-2 ml-8">
             
             <div>{item.title}</div>
           </div>
            ))}
          </div>
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <div>
              <img
                src={managementImg}
                alt="Logo"
                className="h-80  rounded-sm  "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WarehouseManagement;
